<template>
  <v-app  v-bind:style="stylePagina">
    <v-main  v-bind:style="stylePagina">
      <v-container fluid class="pa-0">

        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card dark>
            <v-card-title class="text-h5">
              Ingresaron tus Datos!
            </v-card-title>
            <v-card-text class="text-h6">¡Listo! ¡Se registraron tus datos!</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <section >
          <v-row  justify="center" v-bind:style="styleMain" >

            <v-col  cols="12" sm="12" md="6" lg="8" class="mt-12">
<v-row>
  <v-col cols="12">
    <img src="@/assets/vuse/VUSE_GO_Logo_Blanco.png" width="100%" />
  </v-col>
</v-row>
              <v-row  justify="center" >
                <v-col cols="10" >
                  <v-carousel
                      :show-arrows="false"
                      :hide-delimiters="true"
                      :continuous="true"
                      :cycle="true"
                      height="60px"
                      :interval="700"
                      >
                    <v-carousel-item
                    src="@/assets/vuse/origami/origami-blueberry.png"
                    style="height: 50px" contain ></v-carousel-item>
                    <v-carousel-item
                        src="@/assets/vuse/origami/ORIGAMI_GRAPE.png"
                        style="height: 50px" contain ></v-carousel-item>
                    <v-carousel-item
                        src="@/assets/vuse/origami/ORIGAMI_WATERMELON.png"
                        style="height: 50px" contain ></v-carousel-item>
                  </v-carousel>
                  <img src="" width="100%" />
                </v-col>
              </v-row>
                <v-row   justify="center"  v-bind:style="styleForm" class="pa-12 ma-12" >
                  <v-col cols="12" >
                    Completa el formulario a continuación:
                  </v-col>
                  <v-col cols="12" sm="6" md="6"  >
                    <v-text-field outlined  v-bind:style="styleComponent" v-model="editedItem.nombre" :rules="[rules.required]" label="Nombre Completo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"   >
                    <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.email" label="Email" :rules="emailRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6">
        <span class="block text-gray-600 text-sm text-left font-bold mb-2"
        >Selecciona Fecha de Nacimiento</span
        >
                    <vc-date-picker  class="inline-block h-full" locale="es-PE"    is-dark mode="date"  :first-day-of-week="2" timezone="America/New_York" v-model="editedItem.fechaNacimiento" >
                      <template v-slot="{ inputValue, togglePopover }">
                        <div class="flex items-center">
                          <v-btn

                              @click="togglePopover()"
                          >
                            <v-icon>fas fa-calendar</v-icon>
                          </v-btn>
                          <input
                              :value="inputValue"
                              class="bg-white  text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                              style="color: white; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: white;"
                              readonly
                              :rules="[rules.required]"
                          />
                        </div>
                      </template>
                    </vc-date-picker>

                  </v-col>

                  <v-col  cols="12" sm="6" md="6"  >
                    <v-autocomplete :rules="[rules.required]" class="ma-0" outlined  v-model="editedItem.sexo" :items="sexos" item-value="id" item-text="Sexo" persistent-hint
                                    return-object
                                    single-line label="Genero"></v-autocomplete>
                  </v-col>
                  <v-col  cols="12" sm="6" md="6"  >
                    <v-select  :rules="[rules.required]" class="ma-0" outlined  v-model="editedItem.ref1" :items="modalidad"  persistent-hint

                                    single-line label="Modalidad de consumo"></v-select>
                  </v-col>
                  <v-col  cols="12" sm="6" md="6" >
                    <v-select :rules="[rules.required]" class="ma-0" outlined  v-model="editedItem.ref2" :items="llegaste"  persistent-hint

                              single-line label="¿Cómo llegaste a la tienda?"></v-select>
                  </v-col>
                  <v-col  cols="12" sm="6" md="6"   >
                    <v-row>

                      <v-col  cols="2" sm="2" md="2"  >

                    <v-checkbox
                        v-model="editedItem.aceptoCondicion"
                        :rules="[v => !!v || 'Debes aceptar para continuar']"

                        required
                        style="color: #1E3D90 !important;"
                        color="#1E3D90"
                        class="ma-0"
                    ></v-checkbox> </v-col>
                  <v-col  cols="9" sm="9" md="9"  > Acepta los <a target="_blank" href="https://tunaydocs.s3.amazonaws.com/Autorizacion_Datos_Personales_BAT.pdf">Términos y Condiciones</a>
                  </v-col></v-row>

                  </v-col>


                  <v-col cols="12">
                    <v-alert
                        :value="alerterror"
                        color="red"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      {{error}}
                    </v-alert>
                    <v-btn  style="background-color: #000000 !important; width: 100%; color: white;"  @click="save">PARTICIPAR</v-btn>
                  </v-col>
                </v-row>
              <v-row justify="end" >
                <v-col cols="4">
                  <v-img src="@/assets/vuse/GOTA_ADV.png" height="150px" contain></v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </section>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/infinity.gif"

          />
        </v-overlay>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";


export default {
  name: "vuse-encuesta",
  title: "Vuse",
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      maximafecha: null,
      modalidad: ["Vapeo","Fumo","Vapeo y Fumo"],
      llegaste:["Redes Sociales","Vía pública","De paso","Boca a boca","Otro"],
      sexos: [{id:1, Sexo:"Masculino"}, {id:2, Sexo:"Femenino"}, {id:3, Sexo:"Prefiero No Decirlo"}],
      tiposdoc: [{id:0,tipoDocumento:"Escoger Tipo de Documento",pais:{id:0,activo:false,codigo:'NN',pais:'NO PAIS',importancia: 0}}, {id:1, tipoDocumento:"DNI",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}, {id:2, tipoDocumento:"Carnet Extranjeria",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}, {id:3, tipoDocumento:"Pasaporte",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}],

      menu1: false,
      alerterror: false,
      error:'',
      distritos:[],
      aceptotermino:false,
      rules: {
        required: value => !!value || 'Requerido.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Mail invalido.'
        },
      },
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      paises:[],
      rest: false,
      overlay:false,
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      camporef1: false,
      camporef2:false,
      condiciones: 'Soy Mayor de Edad',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Numero de Documento',
      labelDistrito: 'Distrito',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de nacimiento',
      labelEmail:'Correo Electrónico',
      labelSexo:'Género',
      labelRef1:'',
      labelRef2:'',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      eventodisenio: {},
      stylePagina: {

        fontFamily: 'GothamBlack',
        color: 'white',
        backgroundColor:'black',

      },
      styleComponent:{
        color:'#ffffff',
      },
      styleCabecera:{
        color:'#ffffff',
      },
      ciudades:[],
      provinciaId:0,
      provincias:[],
      paisId:0,
      styleForm:{
        color:'#FFFFFF',
        marginTop:'0px !important',
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: '#000000',
        color:'white'
      },
      tag:'',
      referido:'',
      editedItem:{
        fechaNacimiento:'1993-01-01',
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
telefono:'',
direccion:'',
sexo:{},
tipoDocumento:{},
        ref1:'',
        ref2:'',
      },
      defaultdItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
        telefono:'',
        direccion:'',
        sexo:{},
        tipoDocumento:{},
        ref1:'',
        ref2:'',
      }
    }
  },
  created () {
    this.$vuetify.theme.dark = true
  },
  mounted () {
    this.tagevento =  'encuesta-vuse';
    this.editedItem.fechaNacimiento = new Date(this.editedItem.fechaNacimiento+'T12:00:00.000Z')

  },
  methods: {
    save(){
          var bodyFormData = new FormData();
          this.editedItem.ref1 = this.editedItem.ref1.toString();
      this.editedItem.ref2 = this.editedItem.ref2.toString();
this.overlay = true
          this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
      let eevve = 32
      bodyFormData.append("estadoEventoId",eevve)
      this.editedItem.fechaNacimiento = this.formatDate(this.editedItem.fechaNacimiento)
      bodyFormData.append("persona",JSON.stringify(this.editedItem))
          bodyFormData.append("tagevento",this.tagevento)
          this.rest = true
          axios
              .post('tickets/grabar/formulario',bodyFormData)
              .then(response => {
                let ticketMin = response.data;
                console.log(ticketMin)
                this.editedItem = this.defaultdItem
                this.alertnuevo = true
                this.rest = false
                this.overlay = false
              })
              .catch((error)  => {
                console.log(error);
                this.overlay = false
              });


    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");

    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: white;
}
.theme--light.v-label {
  color: white !important;
}
.v-input .v-label {
  color: white !important;

}

</style>
